<template>
  <div>
    <TitleBar
      v-if="data.title && data.title.title"
      :data="{
        ...data.title,
        font_color_more: data.title.font_color,
        checked_name: data.checked_name
      }"
      :storeId="storeId"
    />
    <div class="product-item-list" :style="{ background: data.background || '' }">
      <div
        v-for="(item, index) in goods"
        :key="index"
        class="product-item-box"
        :style="{ width: `calc(100% / ${ colNum() })`}"
      >
        <KProductItem
          :productData="item"
          type="cms"
          :notImgLazy="true"
          :source="source"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import TitleBar from './TitleBar.vue'
import { buildStoreHomeListingSource, resolveStoreHomeSourceValue } from '@/plugins/utils'

const props = defineProps<{ storeId: number, validProducts: any, data: IStore.IGoods }>()

const goods = computed(() => props.data.elementParams.filter((id: number) => props.validProducts[id]).map((id: number) => props.validProducts[id]))

const colNum = () => {
  const type = Number(props.data.type)
  const goodsLen = goods.value.length

  return type > goodsLen ? goodsLen : type
}
const route = useRoute()
const source = computed(() =>
  buildStoreHomeListingSource(
    resolveStoreHomeSourceValue('goods', { checked_name: props.data.checked_name }),
    undefined,
    route
  )
)
</script>

<style lang="scss" scoped>
.product-item-list{
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
}
.product-item-box{
  padding: 5px;
}
</style>